<template>
  <IntersectionObserver
    class="test-pixel"
    :once="true"
    @appear="onAppear"
  />
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import IntersectionObserver from '~/components/IntersectionObserver.vue';

  export default defineNuxtComponent({
    name: 'TestPixel',

    components: {
      IntersectionObserver,
    },

    props: {
      pixelLink: {
        type: String as PropType<string>,
        required: true,
      },
    },

    methods: {
      onAppear(): void {
        useFetch(this.pixelLink, { credentials: 'include' });
      },
    },
  });
</script>

<style lang="scss" scoped></style>
